export default __webpack_public_path__ + "static/media/Maus-mit-Luftballon.428ab009.png";